module.exports = __webpack_public_path__ + "img/DESC_SORT.ecfd41a9.svg";